export enum PackagesActionTypes {
    API_RESPONSE_SUCCESS = "@@packages/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@packages/API_RESPONSE_ERROR",

    GET_PACKAGES = "@@packages/GET_PACKAGES",
    UPDATE_PACKAGES = "@@packages/UPDATE_PACKAGES",
    ADD_PACKAGES = "@@packages/ADD_PACKAGES",
    DELETE_PACKAGES = "@@packages/DELETE_PACKAGES",
    CLEAR_ERROR = "@@packages/CLEAR_ERROR",
  }
  